module.exports = __webpack_public_path__ + "img/product-1.07bd9840.jpeg";